import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

import { FuelingModeDetailsComponent } from "./fueling-mode-details/fueling-mode-details.component";
import { FuelingModeListComponent } from "./fueling-mode-list/fueling-mode-list.component";

const fuelingModeRoutes: Routes = [
  {
    path: "",
    component: FuelingModeListComponent,
  },
  { path: "reset", redirectTo: "grade", pathMatch: "prefix" },
  {
    path: "fueling-mode",
    component: FuelingModeDetailsComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "fueling-mode/:id",
    component: FuelingModeDetailsComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(fuelingModeRoutes)],
  exports: [RouterModule],
})
export class FuelingModeRoutingModule {}
